module.exports = __webpack_public_path__ + "media/25.842d3e8e.mp3";